import { dispatchActionUpdate } from './../admin/actions';
import { IMenuCategoryCreate, IMenuItemCreate, IMenuItemCreateFull, IMenuItemUpdateFull } from './../../interfaces/index';
import { State } from './../state';
import { IMenuState } from './state';
import { getStoreAccessors } from "typesafe-vuex";
import { ActionContext } from 'vuex';
import { api } from '@/api';
import { commitSetMenu, commitSetMenuCategories, commitSetMenuCategory, commitSetMenuCounter, commitSetMenuItem, commitSetMenuItems, commitRemoveMenuItem } from './mutations';
import { dispatchCheckApiError } from '../main/actions';
import { commitAddNotification, commitRemoveNotification } from '../main/mutations';

type MainContext = ActionContext<IMenuState, State>;

export const actions = {
    async getCategories(context: MainContext) {
        try {
            var menuId=0;
            if (context.rootState.main.ownerProfile){
                menuId = context.rootState.main.ownerProfile.accounts[0].menu.id;
                commitSetMenu(context, context.rootState.main.ownerProfile.accounts[0].menu);
            }
            const response = await api.getCategories(context.rootState.main.token, menuId); 
            if (response) {
                commitSetMenuCategories(context, response.data);
            }
        } catch ( error ) {
            await dispatchCheckApiError(context, error);
        }
    },
    async addCategory(context: MainContext, payload: IMenuCategoryCreate) {
        try {
            const response = await api.addCategory(context.rootState.main.token,
                payload);
            if(response) {
                commitSetMenuCategory(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    }, 
    
    async getAllMenuItems(context: MainContext, menu_id: number) {
        try {
            const response = await api.getAllMenuItems(context.rootState.main.token,
                menu_id);
            if (response) {
                commitSetMenuItems(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },

    async getMenuItems(context: MainContext, category_id: number) {
        try {
            const response = await api.getMenuItems(context.rootState.main.token, category_id);
            if (response) {
                commitSetMenuItems(context, response.data)
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },

    async addMenuItem(context: MainContext, payload: IMenuItemCreateFull) {
        try {
            const response = await api.addMenuItem(context.rootState.main.token, payload);
            if (response) {
                commitSetMenuItem(context, response.data);
                
                commitAddNotification(context, { content: `${response.data.title_translations.es} agregado con éxito`, color: 'success' });
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },

    async updateMenuItem(context: MainContext, payload: {id: number, data: IMenuItemUpdateFull}) {
        try {
            const response = await api.updateMenuItem(context.rootState.main.token, payload.id, payload.data);
            if (response) {
                commitSetMenuItem(context, response.data);
                commitAddNotification(context, { content: `${response.data.title_translations.es} modificado con éxito`, color: 'success' });
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },

    async getMenuCounter(context: MainContext, menu_id: number) {
        try {
            const response = await api.getMenuCounter(context.rootState.main.token, menu_id);
            if (response) {
                commitSetMenuCounter(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },

    async deleteMenuItem(context: MainContext, id: number) {
        try {
            const response = await api.deleteMenuItem(context.rootState.main.token, id);
            if (response) {
                commitRemoveMenuItem(context, id);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    }
};

export const { dispatch } = getStoreAccessors<IMenuState, State>('');

export const dispatchGetCategories = dispatch(actions.getCategories);
export const dispatchAddCategory = dispatch(actions.addCategory);
export const dispatchGetAllMenuItems = dispatch(actions.getAllMenuItems);
export const dispatchGetMenuItems = dispatch(actions.getMenuItems);
export const dispatchAddMenuItem = dispatch(actions.addMenuItem);
export const dispatchGetMenuCounter = dispatch(actions.getMenuCounter);
export const dispatchUpdateMenuItem = dispatch(actions.updateMenuItem);
export const dispatchDeleteMenuItem = dispatch(actions.deleteMenuItem);